import { formatCurrency } from 'shared/utils';
import { CentroCostoTotalsReport } from '../../models/CentroCostoTotalsReport/CentroCostoTotalsReport';
import { Button, Card, Col, Row } from 'react-bootstrap';

export const CostCentreDetails = (props: {
  costCentreData: CentroCostoTotalsReport;
  periodo: string;
  goBackAction: () => void;
  goToMovementsAction: () => void;
}) => {
  return (
    <Card>
      <Card.Header className="text-center">
        {props.costCentreData.denominacionEmpresa}
      </Card.Header>
      <Card.Body>
        {props.costCentreData && !props.costCentreData.esCentroCostoRaiz ? (
          <>
            <p className="fw-semibold text-center">
              {props.costCentreData.denominacionCentroCostoPadre}
            </p>
            <Row>
              <Col>
                <p className="fw-semibold">
                  Denominación de cuenta: {props.costCentreData.denominacionCuenta}
                </p>
              </Col>
              <Col>
                <p className="fw-semibold">
                  Nro. de cuenta: {props.costCentreData.numeroCuenta || 'N/A'}
                </p>
              </Col>
            </Row>
            <p className="fw-semibold">
              Saldo inicial: {formatCurrency(props.costCentreData.saldoInicial)}
            </p>
            <p className="text-center fw-semibold">{props.periodo}</p>
            <Row>
              <Col className="text-center">
                <Button
                  className="me-2"
                  variant="secondary"
                  onClick={props.goToMovementsAction}
                >
                  Ver movimientos del centro de costo
                </Button>
                <Button variant="secondary" onClick={props.goBackAction}>
                  Volver
                </Button>
              </Col>
            </Row>
          </>
        ) : (
          <p className="text-center fw-semibold">{props.periodo}</p>
        )}
      </Card.Body>
    </Card>
  );
};
